import { SurchargeType } from '../config/i18nConfig'
import { useEffect, useMemo, useState } from 'react'
import { getI18NName } from '../components/Combobox/i18n/I18NCombobox'
import { useTranslation } from 'react-i18next'
import useSurchargeTypes from './useSurchargeTypes'

type ReturnProps = {
    surchargeType: SurchargeType
    surchargeTypeName: string
    setId: (id: string) => void
}

export default function useSurchargeType(id?: string, surcharge?: SurchargeType): ReturnProps {
    const { i18n } = useTranslation()

    const [_id, setId] = useState<string>(id)
    const { loaded, surchargeTypes } = useSurchargeTypes()
    const _surchargeType = useMemo(
        () => surcharge || (_id && (surchargeTypes || []).find(surchargeType => surchargeType.id === _id)),
        [_id, loaded, surchargeTypes],
    )
    const surchargeTypeName = useMemo<string>(() => {
        return getI18NName(_surchargeType, i18n.language)
    }, [_surchargeType, i18n.language])

    useEffect(() => {
        setId(id)
    }, [id])

    return { surchargeType: _surchargeType, surchargeTypeName, setId }
}
